import { Lesson } from './types';

export const API_BASE_URL = "";

// Dynamically determine WebSocket URL to connect to the origin server.
const wsProtocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const wsHost = typeof window !== 'undefined' ? window.location.host : 'localhost:3001';
export const WS_BASE_URL = `${wsProtocol}//${wsHost}`;

export const FINGER_COLORS: string[] = [
  'bg-pink-400',    // 0: Left Pinky
  'bg-rose-400',    // 1: Left Ring
  'bg-orange-400',  // 2: Left Middle
  'bg-yellow-400',  // 3: Left Index
  'bg-gray-400',    // 4: Thumbs
  'bg-lime-400',   // 5: Right Index
  'bg-green-400',   // 6: Right Middle
  'bg-cyan-400',    // 7: Right Ring
  'bg-purple-400',  // 8: Right Pinky
];

export const KEY_TO_FINGER: { [key: string]: number } = {
  '`': 0, '1': 0, '2': 1, '3': 2, '4': 3, '5': 3, '6': 5, '7': 5, '8': 6, '9': 7, '0': 8, '-': 8, '=': 8,
  'q': 0, 'w': 1, 'e': 2, 'r': 3, 't': 3, 'y': 5, 'u': 5, 'i': 6, 'o': 7, 'p': 8, '[': 8, ']': 8, '\\': 8,
  'a': 0, 's': 1, 'd': 2, 'f': 3, 'g': 3, 'h': 5, 'j': 5, 'k': 6, 'l': 7, ';': 8, "'": 8,
  'z': 0, 'x': 1, 'c': 2, 'v': 3, 'b': 3, 'n': 5, 'm': 5, ',': 6, '.': 7, '/': 8,
  ' ': 4
};
